import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import media from '../../styles/media.style';
import Section from '../Section';

const Button = styled.div`
  background-color: black;
  color: white;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.5px;
  padding: 15px 70px;
  width: auto;

  ${media.tabletL`
    padding: 30px 120px;
  `};
`;

const GallerySection = ({ entryId, label, locale, url, external }) => (
  <Section id={entryId} options={{ content: { style: { display: 'flex', justifyContent: 'center' } } }}>
    {external ? (
      <a href={url} target="_blank">
        <Button>{label}</Button>
      </a>
    ) : (
      <a href={`/${locale}${url}`}>
        <Button>{label}</Button>
      </a>
    )}
  </Section>
);

GallerySection.defaultProps = {
  entryId: undefined,
};

GallerySection.propTypes = {
  entryId: PropTypes.string,
  label: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  external: PropTypes.bool.isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(GallerySection);



// WEBPACK FOOTER //
// ./src/components/Article/LinkSection.js